// Module
var code = "<mx-horizontal-action-list actions=\"vm.actions\" context=\"vm.selectedItems\" view=\"vm.view\" class=\"mx-grid-actions-panel--actions-list\" ng-class=\"{'mx-grid-actions-panel--actions-list__has-actions': vm.actions.length}\" layout-md=\"row\" layout-align-md=\"end none\"></mx-horizontal-action-list>\r\n";
// Exports
export default code;